import React from "react"
import { Container } from "react-bootstrap"

class BannerSection extends React.Component {
  
  render() {
    return (
      <section className="banner text-center">
        <Container>
                <h1 className="main-heading text-center">About Us</h1>
                <p className="pharagraph">
                Coinsclone builds cutting-edge blockchain solutions that transform innovators' inspiration into digital empires. Our team includes blockchain professionals, innovative thinkers, and talented technologists. We aim to simplify blockchain adoption into the mainstream with innovative, reliable, scalable solutions that support businesses around the world.
                </p>
                <div className="cta-banner justify-content-center">
                <a href="https://calendly.com/mathi-pixelweb/" className="bluebtn">Book a calendly meeting</a>
                </div>
        </Container>
      </section>
    )
  }
}

export default BannerSection
